import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=4716fef8"
import script from "./Agreements.vue?vue&type=script&lang=ts"
export * from "./Agreements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports